import { Address } from '../models/address/address';

export const googleMapsUrl = (address: Address) => {
  const formattedAddress = formatAddressForMaps(address);
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(formattedAddress)}`;
};

export const appleMapsUrl = (address: Address) => {
  const formattedAddress = formatAddressForMaps(address);
  return `https://maps.apple.com/?q=${encodeURIComponent(formattedAddress)}`;
};

function formatAddressForMaps(address: Address) {
  return (
    `${address.address1}, ${address.address2 !== null ? address.address2 + ', ' : ''}` +
    `${address.city}, ${address.stateAbbreviation} ${address.postalCode}`
  );
}
